export const quoteSteps = ['car', 'driver', 'cover', 'quote']
export const checkoutSteps = ['quote', 'cover', 'how?', 'confirm', 'pay']
